import getTimeZoneDisplayName from './getTimeZoneDisplayName';

export default function getTimeZoneDisplayNameWithoutOffset(
    timeZoneId: string | null | undefined
): string {
    const displayName = getTimeZoneDisplayName(timeZoneId);
    return displayName.replace(/\(UTC([-|\+]\d\d:\d\d)?\) */, '').trim();
}
